import {
    GET_METRICS_SUCCESS,
    GET_METRICS_FAIL,
    GET_METRICS,
} from "./actionTypes";

// services data

export const getMetrics = (data) => ({
  type: GET_METRICS,
  payload: data
})

export const getMetricsSuccess = metrics => ({
  type: GET_METRICS_SUCCESS,
  payload: metrics,
})

export const getMetricsFail = error => ({
  type: GET_METRICS_FAIL,
  payload: error,
})
